import * as CHQ from "chq";

enum Status {
  Active = "Active",
  Inactive = "Inactive",
  Draft = "Draft"
}

class SurveyStatus {
  static from(survey: CHQ.Survey) {
    if (!survey) {
      return new SurveyStatus(null);
    }
    if (survey.active) {
      return new SurveyStatus(Status.Active);
    }
    if (survey.responseCount > 0) {
      return new SurveyStatus(Status.Inactive);
    }
    return new SurveyStatus(Status.Draft);
  }

  private status: null | keyof typeof Status;

  constructor(status: null | keyof typeof Status) {
    this.status = status;
  }

  isActive() {
    return this.status === Status.Active;
  }

  isInactive() {
    return this.status === Status.Inactive;
  }

  isDraft() {
    return this.status === Status.Draft;
  }

  toString() {
    return this.status;
  }
}

export default SurveyStatus;
